import React, { Component } from 'react';
import { Input, Modal, Form, Select, Button, message } from 'antd'
import { getMethod, axiosPost } from '../../../server/index'
import { get } from 'lodash'
import {  getCookie } from '../../../public/utils'
import common from '../../../public/common'
class BindEmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_cut_count: 60,
    }
  }
  formactionEmail = React.createRef()

  componentWillUnmount() {
    let { intervalEmail } = this.state
    if (intervalEmail) {
      clearInterval(intervalEmail)
    }
  }

  // 发送邮箱验证码
  sendVFcodeEmail = () => {
    let flag = true
    let { email_cut_count } = this.state
    let _email = get(this.formactionEmail.current.getFieldValue(), "email")
    let email = _email ? _email.trim() : ""
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!(reg.test(email))) {
      flag = false
      this.formactionEmail.current.setFields([{
        errors: ["邮箱未填写或不正确"],
        name: "email",
        value: email,
      }])
    }
    if (email_cut_count < 30) {
      flag = false
    }
    if (flag) {
      this.getVfCodeEmail(email)
    }
  }

  // 获取验证码-邮箱
  getVfCodeEmail = async (email) => {
    let { email_cut_count } = this.state
    let res = await axiosPost(common.eurekaUrlDic + "/auth/send-verify-code", {
      send_id: email,
      type: 3,
      sms: false,
    })
    if (get(res, "data.code") == 200) {
      message.success("验证码发送成功，请及时查收")
      let intervalEmail = setInterval(() => {
        if (email_cut_count > 0) {
          email_cut_count--
        } else {
          email_cut_count = 30
          clearInterval(intervalEmail)
        }
        this.setState({
          intervalEmail,
          email_cut_count
        })
      }, 1000);
    } else {
      message.error('获取验证码失败');
    }
  }

  // 确认绑定邮箱
  confirmBindEmail = () => {
    this.formactionEmail.current.validateFields().then(res => {
      let _email = get(res, "email")
      let _code = get(res, "Address.code")
      let email = _email ? _email.trim() : ""
      let code = _code ? _code.trim() : ""
      axiosPost(common.eurekaUrlDic + "/auth/bind-sms-way", {
        send_id: email,
        verify_code: code,
        account:getCookie('phone'),
        sms: false,
      }).then(res => {
        console.log(res)
        if (get(res, "data.code") === 200) {
          message.success("操作成功")
          setTimeout(() => {
            window.location.reload()
          }, 1000);
        } else if (get(res, "data.message")) {
          message.error(get(res, "data.message"))
        }
      })
    })
  }
  render() {
    let { email_cut_count } = this.state
    return (
      <Modal
        title="绑定邮箱"
        destroyOnClose
        open={this.props.open}
        onOk={this.confirmBindEmail}
        onCancel={this.props.onCancel}
      >
        <div>
          <Form ref={this.formactionEmail} labelCol={{ span: 4 }} requiredMark={false}>
            <Form.Item
              label="邮箱"
              rules={[{ required: true, message: "请输入邮箱地址" }]}
              name={"email"}
            >
              <Input style={{ width: 252, }} placeholder="请输入邮箱地址" />
            </Form.Item>
            <Form.Item label="验证码" name={"Address"} >
              <Input.Group compact>
                <Form.Item
                  rules={[{ required: true,message:"请输入验证码" }]}
                  name={[`Address`, 'code']}
                >
                  <Input style={{ width: 150 }} placeholder="请输入验证码" />
                </Form.Item>
                <Form.Item
                  rules={[{ required: false, }]}
                >
                  <Button disabled={email_cut_count < 60} style={{ width: 102 }} onClick={this.sendVFcodeEmail} type="primary">{email_cut_count < 60 ? `${email_cut_count}s` : "获取验证码"}</Button>
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    );
  }
}

export default BindEmailModal;


// WEBPACK FOOTER //
// ./src/pages/login/components/bindEmail.jsx